import { useCallback, useLayoutEffect, useRef } from 'react';
import ReactCanvasConfetti from 'react-canvas-confetti';

export function Confetti(props: { origin: { x: number; y: number }; onFinish?: () => void }) {
	const refAnimationInstance = useRef<ReactCanvasConfetti['confetti']>(null);

	const getInstance = useCallback((instance: ReactCanvasConfetti['confetti']) => {
		refAnimationInstance.current = instance;
	}, []);

	const makeShot = useCallback(
		(particleRatio: number, opts: ReactCanvasConfetti['props']) => {
			refAnimationInstance.current &&
				refAnimationInstance.current({
					...opts,
					origin: props.origin,
					particleCount: Math.floor(200 * particleRatio),
				});
		},
		[props.origin],
	);

	const fire = useCallback(() => {
		makeShot(0.25, {
			spread: 26,
			startVelocity: 55,
		});

		makeShot(0.2, {
			spread: 60,
		});

		makeShot(0.35, {
			spread: 100,
			decay: 0.91,
			scalar: 0.8,
		});

		makeShot(0.1, {
			spread: 120,
			startVelocity: 25,
			decay: 0.92,
			scalar: 1.2,
		});

		makeShot(0.1, {
			spread: 120,
			startVelocity: 45,
		});
	}, [makeShot]);

	const Component = ReactCanvasConfetti;

	useLayoutEffect(() => {
		fire();

		setTimeout(() => props.onFinish?.(), 3000);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Component
			refConfetti={getInstance}
			style={{
				position: 'fixed',
				pointerEvents: 'none',
				width: '100%',
				height: '100%',
				top: 0,
				left: 0,
			}}
		/>
	);
}
